<script setup lang="ts">
import { ref, onMounted } from 'vue';
import type { FieldSchema } from '../../../types';
import { GetAllStaffService } from '@ShelterModule';

const props = defineProps<{
  disabled?: boolean;
  error?: string;
  field?: FieldSchema;
  placeholder?: string;
  required?: boolean;
}>();

const model = defineModel<string>();

const allStaff = ref();
const loading = ref(false);

onMounted(() => getStaff());

function getStaff() {
  loading.value = true;

  GetAllStaffService(props.field?.settings.staffType)
    .then((result: any) => {
      allStaff.value = result.filter(
        (staff: any) => staff.full_name !== null && staff.full_name.toLowerCase() !== 'af staff'
      );

      // Synced bite data may hydrate the model as a person object instead of a plain name string.
      const current: any = model.value;
      const name = typeof current === 'string' ? current : current?.full_name;
      const objectId = current?._id?.$oid ?? (typeof current?._id === 'string' ? current._id : undefined);

      const match =
        result.find((staff: any) => staff.full_name === name) ??
        (objectId ? result.find((staff: any) => staff._id?.$oid === objectId) : undefined);

      if (match) model.value = match;
    })
    .finally(() => (loading.value = false));
}
</script>

<template>
  <AFieldDropdown
    v-model="model"
    optionLabel="full_name"
    :class="['h-9 w-full text-sm', { 'af-field-error': !!error }]"
    :disabled="loading"
    :error
    :options="allStaff"
    :placeholder
  />
</template>
